<headerCustom></headerCustom>


<div class="dashboardContainer customizeRtsScrollBar">
    <div class="dashboardMainHolder">
        <div class="container">

            <div class="row justify-content-md-center text-center">

                <div class="col-md-12 col-sm-12 col-xs-12 fontCustomCss-4">
                    <div class="text-center">Welcome!</div>

                </div>
                <div class="col-md-2 col-sm-12 col-xs-12 inputDivContainer"
                    *ngIf="userRoll==3 || userRoll==7 || (userRoll==4 && towerInfoList.length > 1) || (userRoll==6 && towerInfoList.length > 1)">
                    <label>Select IBU: </label>
                    <select class="form-control" [(ngModel)]="selectedIbuId" (ngModelChange)="setIbuId()">
                        <ng-container *ngFor="let ibulist of ibuList; let i = index;">
                            <option value="{{ibulist.ibuId}}">
                                {{ibulist.ibuName}}
                            </option>
                        </ng-container>
                    </select>
                </div>
                <div class="col-md-2 col-sm-12 col-xs-12 inputDivContainer"
                    *ngIf="userRoll==3  || userRoll==7 || (userRoll==4 && towerInfoList.length > 1) || (userRoll==6 && towerInfoList.length > 1)">
                    <label>Select Function: </label>
                    <select class="form-control" [(ngModel)]="selectedFunctionId" (ngModelChange)="onChangeFunction()"
                        [disabled]='(functionList?.length) ? false : true'>
                        <option value="null">Select Function</option>
                        <ng-container *ngFor="let funlist of functionList; let i = index;">
                            <option value="{{funlist.functionId}}">
                                {{funlist.functionName}}
                            </option>
                        </ng-container>
                    </select>
                </div>
                <div class="col-md-3 col-sm-12 col-xs-12 inputDivContainer"
                    *ngIf="userRoll==3 || userRoll==7 || (userRoll==4 && towerInfoList.length > 1) || (userRoll==6 && towerInfoList.length > 1)">
                    <label>Select Sub Function/Tower:</label>
                    <select class="form-control" [(ngModel)]="selectedTowerId" (ngModelChange)="setTowerId()"
                        [disabled]='(towerInfoList?.length) ? false : true'>
                        <option value="null">Select Sub Function/Tower</option>
                        <ng-container *ngFor="let towerInfo of towerInfoList; let i = index;">
                            <option value="{{towerInfo.towerId}}">
                                {{towerInfo.towerName}}
                            </option>
                        </ng-container>
                    </select>
                </div>

                <div class="row justify-content-md-center dashboardBody">
                    <div class="col-md-3 col-sm-6 col-xs-12 dashboard_mainbox" [routerLink]="['/interested-users']"
                        *ngIf="userRoll==3">
                        <div class="reportDashboard-item text-center">
                            <div class="icon">
                                <i class="fa fa-user-circle"></i>
                            </div>
                            <button type="button" [routerLink]="['/interested-users']">Interested Applicant</button>
                        </div>
                        <div class="reportDashboard-text text-center">
                            <span>Click Here to Add/Modify Interested Applicant</span>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-xs-12 dashboard_mainbox" [routerLink]="['/addResource']"
                        *ngIf="userRoll==3 || userRoll==4 || userRoll==6 || userRoll==7">
                        <div class="reportDashboard-item text-center">
                            <div class="icon">
                                <i class="fa fa-user"></i>
                            </div>
                            <button type="button" [routerLink]="['/addResource']">TR Nominees</button>
                        </div>
                        <div class="reportDashboard-text text-center">
                            <span>Click Here to Add/Modify TR Nominees</span>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-xs-12 dashboard_mainbox" *ngIf="userRoll==4"
                        [routerLink]="['/managerRating']">
                        <div class="reportDashboard-item text-center">
                            <div class="icon">
                                <i class="fas fa-user-shield" [routerLink]="['/managerRating']"></i>
                            </div>
                            <button type="button" [routerLink]="['/managerRating']">Manager Section</button>
                            <div class="line-dec"></div>
                        </div>
                        <div class="reportDashboard-text text-center">
                            <span>Click Here to Rate Individuals (TM)</span>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-xs-12 dashboard_mainbox"
                        *ngIf="userRoll==2 || userRoll==4 || userRoll==3 || userRoll==6 || userRoll==7"
                        [routerLink]="['/scoreComputation']">
                        <div class="reportDashboard-item text-center">
                            <div class="icon">
                                <i class="fas fa-star"></i>
                            </div>
                            <button type="button" [routerLink]="['/scoreComputation']">Compute Score</button>
                            <div class="line-dec"></div>
                        </div>
                        <div class="reportDashboard-text text-center">
                            <span>Click Here to See Ratings of Individuals</span>
                        </div>
                    </div>
                    <div class="col-md-12 col-sm-6 col-xs-12 dashboard_mainbox" *ngIf="userRoll==1"
                        [routerLink]="['/adminDashboard']">
                        <div class="reportDashboard-item text-center">
                            <div class="icon">
                                <i class="fas fa-user-lock"></i>
                            </div>
                            <button type="button" [routerLink]="['/adminDashboard']">Admin</button>
                            <div class="line-dec"></div>
                        </div>

                    </div>
                    <div class="col-md-3 col-sm-6 col-xs-12 dashboard_mainbox"
                        *ngIf="userRoll==4 || userRoll==3 || userRoll==6 || userRoll==7" [routerLink]="['/userDashboard']">
                        <div class="reportDashboard-item text-center">
                            <div class="icon">
                                <i class="fas fa-chart-bar"></i>
                            </div>
                            <button type="button" [routerLink]="['/userDashboard']">Dashboard</button>
                            <div class="line-dec"></div>
                        </div>
                        <div class="reportDashboard-text text-center">
                            <span>Click Here to See Performance Dashboard of Individuals</span>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-xs-12 dashboard_mainbox" *ngIf="userRoll==3 || userRoll==4"
                        [routerLink]="['/intervention']">
                        <div class="reportDashboard-item text-center">
                            <div class="icon">
                                <i class="fas fa-bars"></i>
                            </div>
                            <button type="button" [routerLink]="['/intervention']">Interventions</button>
                            <div class="line-dec"></div>
                        </div>
                        <div class="reportDashboard-text text-center">
                            <span>Click Here to Add Interventions Against Skills</span>
                        </div>
                    </div>

                    <div class="col-md-3 col-sm-6 col-xs-12 dashboard_mainbox" *ngIf="userRoll==1"
                        [routerLink]="['/manageUsers']">
                        <div class="reportDashboard-item text-center">
                            <div class="icon">
                                <i class="fas fa-user-tie"></i>
                            </div>
                            <button type="button" [routerLink]="['/manageUsers']">Management User</button>
                            <div class="line-dec"></div>
                        </div>
                        <div class="reportDashboard-text text-center">
                            <span>Add/Update Management Users</span>
                        </div>
                    </div>

                    <div class="col-md-3 col-sm-6 col-xs-12 dashboard_mainbox" *ngIf="userRoll==3"
                        [routerLink]="['/funSkillMaster']">
                        <div class="reportDashboard-item text-center">
                            <div class="icon">
                                <i class="fa fa-tasks"></i>
                            </div>
                            <button type="button" [routerLink]="['/funSkillMaster']">Functional Skill Config</button>
                            <div class="line-dec"></div>
                        </div>
                        <div class="reportDashboard-text text-center">
                            <span>Add/Update Functional Skill Details</span>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-xs-12 dashboard_mainbox" *ngIf="userRoll==3"
                        [routerLink]="['/behSkillMaster']">
                        <div class="reportDashboard-item text-center">
                            <div class="icon">
                                <i class="fa fa-user-cog"></i>
                            </div>
                            <button type="button" [routerLink]="['/behSkillMaster']">Behavioral Skill Config</button>
                            <div class="line-dec"></div>
                        </div>
                        <div class="reportDashboard-text text-center">
                            <span>Add/Update Behavioral Skill Details</span>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-xs-12 dashboard_mainbox" *ngIf="userRoll==3 || userRoll==4 || userRoll==7"
                        [routerLink]="['/rating-history']">
                        <div class="reportDashboard-item text-center">
                            <div class="icon">
                                <i class="fa fa-history"></i>
                            </div>
                            <button type="button" [routerLink]="['/rating-history']">Rating History</button>
                            <div class="line-dec"></div>
                        </div>
                        <div class="reportDashboard-text text-center">
                            <span>List User Rating History Details</span>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-xs-12 dashboard_mainbox" *ngIf="userRoll==3 || userRoll==4 || userRoll==7"
                        [routerLink]="['/competencyReport']">
                        <div class="reportDashboard-item text-center">
                            <div class="icon">
                                <i class="fa fa-list-alt"></i>
                            </div>
                            <button type="button" [routerLink]="['/competencyReport']">Competency Report</button>
                            <div class="line-dec"></div>
                        </div>
                        <div class="reportDashboard-text text-center">
                            <span>Click here to see consolidated Competency Report</span>
                        </div>
                    </div>


                    <div class="col-md-12 col-sm-6 col-xs-12 dashboard_mainbox" *ngIf="userRoll==5"
                        [routerLink]="['/selfRating']">
                        <div class="reportDashboard-item text-center">
                            <div class="icon">
                                <i class="fas fa-bars"></i>
                            </div>
                            <button type="button" [routerLink]="['/selfRating']">Self Rating</button>
                            <div class="line-dec"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottomSeprationWrapper">
                <div class="bottomSepration">
                    <div class="triangleShape">
                        <i class="fa fa-sort-up"></i>
                    </div>
                    <p>Select section of your choice</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="footer">
    <p> &copy; 2021 NIIT Talent Readiness, All rights reserved. Powered by NEC.</p>
</div>


<div class="loader" *ngIf="loading || loadingTower">
    <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>